import JSONAPIClient from '../../JSONAPIClient'

JSONAPIClient.define('dashboard_team_member',
  { name: '' }, { collectionPath: 'dashboard/team_members' })
